import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import MetricContentPDFLayout from "./MetricContentPDFLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";

const MetricContentPDFExport = ({
  entityName,
  category,
  persona,
  location,
  market,
  llm,
  focusAreas,
  tableData,
  filterKeys,
  isDisabled = false,
}) => {
  const pdfContentRef = useRef(null);

  const validatePDFData = () => {
    // Check if we have at least entity name and either focus areas or table data
    if (!entityName) {
      toast.warn("Entity name is required for PDF export");
      return false;
    }

    const hasFocusAreas = focusAreas && Object.keys(focusAreas).length > 0;
    const hasTableData = tableData && tableData.length > 0;

    if (!hasFocusAreas && !hasTableData) {
      toast.warn("No focus areas or content data available to export");
      return false;
    }

    return true;
  };

  const handlePrint = useReactToPrint({
    contentRef: pdfContentRef,
    documentTitle: `${entityName || "brand"}-contentmap-report.pdf`,
    removeAfterPrint: true,
    pageStyle: `
      @page {
        size: A4 landscape;
        margin-left: 0.5in;
        margin-right: 0.5in;
        margin-bottom: 0.5in;
        margin-top: 0.75in;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          color-adjust: exact;
        }
      }
    `,
  });

  const handleClick = () => {
    if (!validatePDFData()) {
      return;
    }
    console.log("Export button clicked");
    handlePrint();
  };

  return (
    <>
      {/* Hidden component for printing */}
      <div style={{ display: "none" }}>
        <div ref={pdfContentRef}>
          <MetricContentPDFLayout
            entityName={entityName}
            category={category}
            persona={persona}
            location={location}
            market={market}
            llm={llm}
            focusAreas={focusAreas}
            tableData={tableData}
            filterKeys={filterKeys}
          />
        </div>
      </div>

      <MUIIconButton
        title="Download as PDF"
        onClick={handleClick}
        className="downloadBtn"
        disabled={isDisabled}
      >
        <FontAwesomeIcon icon={faDownload} />
      </MUIIconButton>
    </>
  );
};

export default MetricContentPDFExport;
